import React, {useState, useEffect, useMemo} from "react";
import WhenCondition from "./WhenCondition";
import {LoaderTypes} from "../../../containers/RegistrationLoginPage/types";
import FieldLoader from "./FieldLoader";
import {FormUlList} from "./loaderStyled";

interface FieldWrapper {
    visible: boolean;
    whenFields?: string[];
    fieldConditionHandler?: <T>(value: T) => boolean;
    children: React.ReactNode;
    addEmptyLi?: boolean;
    loading?: boolean;
    loaderType?: LoaderTypes;
    debug?: boolean;
    fullWidthDiv?: boolean;
}
const FieldWrapper: React.FC<FieldWrapper> = ({
    visible,
    whenFields,
    fieldConditionHandler,
    children,
    addEmptyLi = false,
    loading = false,
    loaderType = "Select",
    debug = false,
    fullWidthDiv = false,
}: FieldWrapper) => {
    const [isVisible, setIsVisible] = useState(visible);

    const [whenConditionObject, setWhenConditionObject] = useState(() => {
        if (whenFields) {
            const whenFieldsMap: {
                [key: string]: Record<string, unknown> | string;
            } = {};
            whenFields.map((val) => {
                whenFieldsMap[val] = "";
            });
            return whenFieldsMap;
        } else {
            return {};
        }
    });
    useEffect(() => {
        setIsVisible(visible);
    }, [visible]);

    useEffect(() => {
        if (fieldConditionHandler) {
            if (fieldConditionHandler(whenConditionObject)) {
                !isVisible && setIsVisible(true);
            } else {
                isVisible && setIsVisible(false);
            }
        }
    }, [whenConditionObject, fieldConditionHandler, isVisible, loading]);
    if (debug) {
        console.log(isVisible);
    }

    return useMemo(() => {
        if (loading) {
            console.log("loading", loading);
            return (
                <FieldLoader
                    loaderType={loaderType}
                    addEmptyLi={addEmptyLi}
                    fullWidthDiv={fullWidthDiv}
                />
            );
        } else {
            return (
                <>
                    {whenFields && (
                        <WhenCondition
                            whenFields={whenFields}
                            setWhenConditionObject={setWhenConditionObject}
                        />
                    )}
                    {isVisible && (
                        <>
                            <FormUlList fullWidthDiv={fullWidthDiv}>{children}</FormUlList>
                            {addEmptyLi && <FormUlList />}
                        </>
                    )}
                </>
            );
        }
    }, [loading, loaderType, isVisible, whenFields, children, addEmptyLi, fullWidthDiv]);
};

export default FieldWrapper;
